'use strict'

var styler = require('./build/index').default

exports = module.exports = styler

exports.flat     = require('./build/flat').default
exports.expanded = require('./build/expanded').default

exports['default'] = styler


//////////////////
// WEBPACK FOOTER
// ./~/react-styling/index.common.js
// module id = 17
// module chunks = 0